import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const getByUser = async (state: IStore, clubId: string | number, userId: number) => {
  const response = await request.get(`${api.admin.clubs}${clubId}/memberships/?user=${userId}`);

  if (response.error) {
    return { errors: { memberships: { msg: 'Error retrieving the player memberships.' } } };
  }

  const memberships = state.adminMemberships.memberships;

  return {
    adminMemberships: {
      memberships: memberships.filter(membership => membership.user.id === userId).concat(response)
    }
  };
};
